/* ==========================================================================
   New arrivals (sections/ll-new-arrivals.liquid, assets/ll-new-arrivals.css)

     1  setup, money, dates
     2  the feed: templates/collection.ll-new-feed.liquid, newest first
     3  the binder: the newest singles in 9-pocket pages, page turns, the
        card lifted out of its sleeve, also just in, and new listings filed
        in while the page is open
     4  the numbers in the hero
     5  since your last visit
     6  the drop log: week tiles, the filter bar, the week day by day,
        complete a set
     7  cards
    10  the basket: add, set runs, the basket bar, free delivery, protection
    11  the watchlist (the shared ll_watchlist contract)
    12  toasts, boot

   Nothing invents a price: every figure is the shop's own live price,
   compare-at price or free delivery threshold. Motion is off for
   prefers-reduced-motion, and the binder stops turning when it is off
   screen, the tab is hidden, or a pointer or keyboard is on it, and for
   good once someone turns a page themselves.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-llna]');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');

  /* ------------------------------------------------------------- 1 setup */
  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-llna-cfg]').textContent); } catch (e) {}
  var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var canHover = !!(window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches);
  var DAY = 864e5;
  var TZ = 'Europe/London';
  var WEEKS = Math.max(4, Math.min(12, Number(cfg.weeks) || 8));
  var FREE = Number(cfg.freeShip) || 6000;

  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  var LS = null, SS = null;
  try { LS = window.localStorage; } catch (e) {}
  try { SS = window.sessionStorage; } catch (e) {}
  function readJSON(store, k, fb) { if (!store) return fb; try { var v = store.getItem(k); return v ? JSON.parse(v) : fb; } catch (e) { return fb; } }
  function writeJSON(store, k, v) { if (!store) return; try { store.setItem(k, JSON.stringify(v)); } catch (e) {} }

  var NUT = '<svg class="llna-nut" viewBox="0 0 64 64" aria-hidden="true" focusable="false"><path fill="currentColor" fill-rule="evenodd" d="M32 4 56 18v28L32 60 8 46V18Z M32 21a11 11 0 1 1 0 22a11 11 0 1 1 0-22Z"/></svg>';
  var BASKET = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7.2 8 9.6 3.6l1.8 1L9.5 8h5l-1.9-3.4 1.8-1L16.8 8H21l-1.6 10.1A2.3 2.3 0 0 1 17.1 20H6.9a2.3 2.3 0 0 1-2.3-1.9L3 8Zm-1.9 2 1.3 7.8c0 .1.1.2.3.2h10.2c.2 0 .3-.1.3-.2L18.7 10Z"/></svg>';

  /* Money in pence throughout, printed through the shop's own format. */
  function money(p) {
    var fmt = cfg.money || '£{{amount}}';
    var n = (Number(p) || 0) / 100;
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    function fixed(dp, thou, dec) {
      var parts = n.toFixed(dp).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(dec);
    }
    var out;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': out = fixed(0, ',', '.'); break;
      case 'amount_with_comma_separator': out = fixed(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = fixed(0, '.', ','); break;
      default: out = fixed(2, ',', '.');
    }
    return m ? fmt.replace(m[0], out) : '£' + out;
  }

  /* Whole pounds without the pence: free delivery over £60, not £60.00. */
  function moneyShort(p) { var m = money(p); return (Number(p) || 0) % 100 === 0 ? m.replace(/[.,]00(?=\D*$)/, '') : m; }

  /* Dates are the shop's: UK time, whatever the shopper's clock says. */
  function fmt(opts) { try { return new Intl.DateTimeFormat('en-GB', Object.assign({ timeZone: TZ }, opts)); } catch (e) { return new Intl.DateTimeFormat('en-GB', opts); } }
  var F_KEY = fmt({ year: 'numeric', month: '2-digit', day: '2-digit' });
  var F_TIME = fmt({ hour: '2-digit', minute: '2-digit', hour12: false });
  var F_WD = fmt({ weekday: 'short' });
  var F_WDL = fmt({ weekday: 'long' });
  var F_DM = fmt({ day: 'numeric', month: 'short' });
  var F_DML = fmt({ day: 'numeric', month: 'long' });
    function dayKey(ms) {
    var p = {};
    F_KEY.formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
    return p.year + '-' + p.month + '-' + p.day;
  }
  /* Noon UTC on a day key, so formatting it in UK time can never slip a day. */
  function keyMs(key) { var a = key.split('-'); return Date.UTC(+a[0], +a[1] - 1, +a[2], 12); }
  function addDays(key, n) { return dayKey(keyMs(key) + n * DAY); }
  function dayDiff(a, b) { return Math.round((keyMs(a) - keyMs(b)) / DAY); }
  /* The Monday a day's week starts on (weeks run Monday to Sunday, UK). */
  function weekOf(key) { var dow = new Date(keyMs(key)).getUTCDay(); return addDays(key, -((dow + 6) % 7)); }
  var todayKey = dayKey(Date.now());
  function refreshToday() { todayKey = dayKey(Date.now()); }

  function whenWord(it) {
    var d = dayDiff(todayKey, it.day);
    if (d <= 0) return F_TIME.format(new Date(it.ts));
    if (d === 1) return 'Yesterday';
    if (d < 7) return F_WD.format(new Date(it.ts));
    return F_DM.format(new Date(it.ts));
  }
  function whenLong(it) {
    var d = dayDiff(todayKey, it.day);
    if (d <= 0) return 'Listed today at ' + F_TIME.format(new Date(it.ts));
    if (d === 1) return 'Listed yesterday at ' + F_TIME.format(new Date(it.ts));
    if (d < 7) return 'Listed ' + F_WDL.format(new Date(it.ts));
    return 'Listed ' + F_DML.format(new Date(it.ts));
  }
  function dayTitle(key) {
    var ms = keyMs(key);
    return F_WDL.format(new Date(ms)) + ' ' + F_DML.format(new Date(ms));
  }
  function dayShort(key) {
    var ms = keyMs(key);
    return F_WD.format(new Date(ms)) + ' ' + F_DM.format(new Date(ms));
  }

  /* Set names arrive in capitals from the listing titles (PERFECT ORDER). */
  var KEEP_UP = { gx: 'GX', v: 'V', vmax: 'VMAX', vstar: 'VSTAR', tcg: 'TCG', ex: 'ex', 'op-17': 'OP-17', 'op-16': 'OP-16', 'op-15': 'OP-15', 'eb-02': 'EB-02', mtg: 'MTG', uk: 'UK' };
  var SMALL = { of: 1, the: 1, and: 1, in: 1, a: 1, to: 1, at: 1, on: 1, for: 1 };
  function titleCase(s) {
    s = String(s || '').trim();
    if (!s || s !== s.toUpperCase()) return s;
    return s.toLowerCase().split(/\s+/).map(function (w, i) {
      if (KEEP_UP[w]) return KEEP_UP[w];
      if (i > 0 && SMALL[w]) return w;
      if (/^\d/.test(w)) return w;
      return w.charAt(0).toUpperCase() + w.slice(1);
    }).join(' ');
  }

  function gameOf(it) {
    var ty = String(it.ty || '').toLowerCase(), ve = String(it.ve || '').toLowerCase();
    if (ty === 'pokemon' || ty === 'pkmontoys' || ve === 'pokémon' || ve === 'pokemon') return 'pokemon';
    if (ty === 'disney') return ve.indexOf('ravensburger') > -1 ? 'lorcana' : 'disney';
    if (ty === 'one piece' || (ty === 'single card' && ve === 'bandai')) return 'onepiece';
    if (ty === 'mtg' || ty.indexOf('magic') > -1) return 'magic';
    if (ty === 'digimon') return 'digimon';
    if (ty.indexOf('yu-gi-oh') > -1) return 'yugioh';
    if (ty === 'accessory') return 'acc';
    return 'other';
  }
  var GAMES = [['pokemon', 'Pokémon'], ['lorcana', 'Lorcana'], ['onepiece', 'One Piece'], ['magic', 'Magic'], ['digimon', 'Digimon'], ['yugioh', 'Yu-Gi-Oh!'], ['disney', 'Disney']];

  function sized(url, w) {
    if (!url) return '';
    return /[?&]width=\d+/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=' + w) : url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ------------------------------------------------------------- 2 the feed */
  var items = [];            // this collection, newest first
  var byHandle = {};
  var byVariant = {};
  var oldestLoaded = Infinity;
  var fullSpan = false;      // true once the feed reaches back past the window
  /* The first day the drop log shows, and the first the feed must reach:
     the start of the oldest week on show, or 30 days back for the hero's
     30 day figure, whichever is earlier. */
  function windowStart() { return addDays(weekOf(todayKey), -7 * (WEEKS - 1)); }
  function needFrom() { var d30 = addDays(todayKey, -30), w = windowStart(); return d30 < w ? d30 : w; }

  function norm(it) {
    it.ts = (Number(it.c) || 0) * 1000;
    it.day = dayKey(it.ts);
    it.week = weekOf(it.day);
    it.game = gameOf(it);
    it.url = '/products/' + it.h;
    it.fromT = titleCase(it.f);
    it.off = it.w > it.p ? it.w - it.p : 0;
    it.pct = it.w > it.p ? Math.round((it.w - it.p) / it.w * 100) : 0;
    it.future = !!(it.r && it.r > todayKey);
    if (it.a) it.st = it.future ? 'pre' : (it.k !== 'single' && it.q > 0 && it.q <= 3 ? 'low' : 'in');
    else it.st = it.future ? 'due' : 'out';
    return it;
  }
  function index(list) {
    list.forEach(function (it) {
      byHandle[it.h] = it;
      if (it.v) byVariant[it.v] = it;
    });
  }
  /* A ?view= answers as HTML, so it is read as text. Never send Accept:
     application/json to it: Shopify then answers with its own JSON instead. */
  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (t) { return JSON.parse(t); });
  }
  function merge(list, prepend) {
    var add = [];
    list.forEach(function (raw) {
      if (!raw || !raw.h || byHandle[raw.h]) return;
      add.push(norm(raw));
    });
    if (!add.length) return add;
    index(add);
    items = prepend ? add.concat(items) : items.concat(add);
    items.sort(function (a, b) { return b.ts - a.ts; });
    add.forEach(function (it) { if (it.ts < oldestLoaded) oldestLoaded = it.ts; });
    return add;
  }
  var CACHE = 'llna_feed_v3_' + (cfg.handle || '');
  function loadFeed() {
    var cached = readJSON(SS, CACHE, null);
    if (cached && cached.t && Date.now() - cached.t < 180000 && cached.items && cached.items.length) {
      merge(cached.items);
      fullSpan = !!cached.full;
      return Promise.resolve();
    }
    var raw = [];
    function page(n) {
      return getJSON(cfg.feed + '&page=' + n).then(function (j) {
        raw = raw.concat(j.items || []);
        merge(j.items || []);
        var last = j.items && j.items.length ? j.items[j.items.length - 1] : null;
        var more = last && dayKey(last.c * 1000) >= needFrom() && n < (j.pages || 1);
        if (more && n < 6) return page(n + 1);
        /* Complete when the feed reached back far enough or ran out; capped
           at six pages, the counts are "at least" and say so with a +. */
        fullSpan = !more;
      });
    }
    return page(1).then(function () {
      writeJSON(SS, CACHE, { t: Date.now(), full: fullSpan, items: raw });
    });
  }

  /* ------------------------------------------------------------- 3 the binder */
  /* The newest singles in a 9-pocket binder: two pages side by side when
     there is room, one when there is not (the stylesheet decides with a
     container query; this only asks which it is). The server files the
     first spread so it paints with the page; this takes over from the feed. */
  var binder = $('[data-binder]');
  var spreadEl = binder ? $('[data-spread]', binder) : null;
  var pageL = binder ? $('[data-page="l"] .llna-pockets', binder) : null;
  var pageR = binder ? $('[data-page="r"] .llna-pockets', binder) : null;
  var peek = binder ? $('[data-peek]', binder) : null;
  var hero = $('.llna-hero');
  var singles = [];
  var view = 0;
  var turning = false, autoT = 0, autoOff = reduce, heroAway = false, hold = false;
  var TURN = Math.max(5, Number(cfg.turn) || 9) * 1000;
  var MAX_CARDS = 72;

  function isSolo() { return !pageR || getComputedStyle(pageR.parentNode).display === 'none'; }
  function perView() { return isSolo() ? 9 : 18; }
  function pagesTotal() { return Math.max(1, Math.ceil(singles.length / perView())); }
  /* The sticker's tilt, the same rule as snippets/ll-na-pocket. */
  function tilt(h) { return (String(h).length % 9) - 4; }
  function pocketHTML(it, i, eager) {
    if (!it) return '<li class="llna-pk is-empty" aria-hidden="true"></li>';
    var isNew = sinceMs && it.ts > sinceMs;
    return '<li class="llna-pk' + (it._fresh ? ' is-fresh' : '') + '" data-h="' + esc(it.h) + '" style="--i:' + i + ';--r:' + tilt(it.h) + 'deg">' +
      '<a class="llna-pk__card" href="' + esc(it.url) + '">' +
        '<img src="' + esc(sized(it.i, 320)) + '" srcset="' + esc(sized(it.i, 210)) + ' 210w, ' + esc(sized(it.i, 320)) + ' 320w, ' + esc(sized(it.i, 420)) + ' 420w" sizes="(max-width: 760px) 44vw, 210px" alt="" ' + (eager ? '' : 'loading="lazy" ') + 'decoding="async">' +
        '<span class="llna-sr">' + esc(it.t) + ', ' + (it.a ? esc(money(it.p)) : 'sold out') + '</span>' +
      '</a>' +
      (isNew ? '<span class="llna-pk__new" aria-hidden="true">' + NUT + 'New</span>' : '') +
      '<span class="llna-pk__tag' + (it.a ? '' : ' is-sold') + '" aria-hidden="true">' + esc(it.a ? money(it.p) : 'Sold') + '</span>' +
    '</li>';
  }
  function pageHTML(start, offset, eager) {
    var out = '';
    for (var i = 0; i < 9; i++) out += pocketHTML(singles[start + i], (offset || 0) + i, eager);
    return out;
  }
  function file(list) {
    if (reduce || !list) return;
    list.classList.remove('is-filing');
    void list.offsetWidth;
    list.classList.add('is-filing');
  }
  function paintView(animate) {
    if (!pageL) return;
    pageL.innerHTML = pageHTML(view, 0, true);
    if (pageR && !isSolo()) pageR.innerHTML = pageHTML(view + 9, 9, true);
    if (animate) { file(pageL); if (!isSolo()) file(pageR); }
    paintBar();
  }
  function rangeWords(list) {
    if (!list.length) return '';
    var a = list[0], b = list[list.length - 1];
    if (a.day === b.day) {
      var d = dayDiff(todayKey, a.day);
      var when = d === 0 ? 'Listed today' : d === 1 ? 'Listed yesterday' : 'Listed ' + dayShort(a.day);
      return when + ', ' + F_TIME.format(new Date(b.ts)) + ' to ' + F_TIME.format(new Date(a.ts));
    }
    return 'Listed ' + F_DM.format(new Date(b.ts)) + ' to ' + F_DM.format(new Date(a.ts));
  }
  function paintBar() {
    var el = $('[data-binder-page]');
    if (!el || !singles.length) return;
    var per = perView(), cur = Math.floor(view / per), total = pagesTotal();
    var first = cur * (per / 9) + 1, last = first + per / 9 - 1;
    var label = per === 9 ? '<b>Page ' + first + '</b>' : '<b>Pages ' + first + '–' + last + '</b>';
    el.innerHTML = label + ' of ' + (total * per / 9) + ' &middot; ' + esc(rangeWords(singles.slice(view, view + per)));
    var prev = $('[data-turn="-1"]'), next = $('[data-turn="1"]');
    if (prev) prev.disabled = cur <= 0;
    if (next) next.disabled = cur >= total - 1;
  }
  function preload(start, n) {
    var urls = singles.slice(start, start + n).map(function (it) { return it.i ? sized(it.i, 320) : ''; }).filter(Boolean);
    return Promise.race([
      Promise.all(urls.map(function (u) { return new Promise(function (ok) { var im = new Image(); im.onload = im.onerror = ok; im.src = u; }); })),
      new Promise(function (ok) { setTimeout(ok, 900); })
    ]);
  }
  /* Turn a page. Forward, the right page lifts and swings over to the left;
     its back is the next left page, and the right page it uncovers is
     already the next one. Back is the mirror of that. On one page, the page
     swings away to reveal the next (or swings in, going back). */
  function turn(dir, byUser) {
    if (turning || !singles.length || !pageL) return;
    var per = perView(), cur = Math.floor(view / per), total = pagesTotal();
    var nextPage = cur + dir;
    if (nextPage < 0 || nextPage >= total) {
      if (byUser) return;
      nextPage = 0;
    }
    if (nextPage === cur) return;
    var d = nextPage > cur ? 1 : -1;
    var to = nextPage * per;
    if (byUser) { autoOff = true; clearTimeout(autoT); }
    hidePeek(true);
    /* Cards are filed in once, on arrival; a turned page is already full. */
    if (pageL) pageL.classList.remove('is-filing');
    if (pageR) pageR.classList.remove('is-filing');
    if (reduce) { view = to; paintView(false); return; }
    turning = true;
    preload(to, per).then(function () {
      var ms = isSolo() ? 760 : 900;
      var leaf = document.createElement('div');
      leaf.setAttribute('aria-hidden', 'true');
      leaf.style.setProperty('--turn-ms', ms + 'ms');
      if (isSolo()) {
        if (d > 0) {
          leaf.className = 'llna-leaf llna-leaf--solo';
          leaf.innerHTML = '<div class="llna-page llna-leaf__front llna-page--l"><ol class="llna-pockets">' + pageHTML(view, 0, true) + '</ol></div>';
          pageL.innerHTML = pageHTML(to, 0, true);
        } else {
          leaf.className = 'llna-leaf llna-leaf--solo-in';
          leaf.innerHTML = '<div class="llna-page llna-leaf__front llna-page--l"><ol class="llna-pockets">' + pageHTML(to, 0, true) + '</ol></div>';
        }
      } else {
        leaf.className = 'llna-leaf ' + (d > 0 ? 'llna-leaf--fwd' : 'llna-leaf--back');
        /* The page turns on the middle of the spine, as a bound page does, so
           its back lands exactly on the page opposite. Measured from the
           layout rather than assumed, so it holds at every width. */
        var sp = spreadEl.getBoundingClientRect();
        var sb = $('.llna-binder__spine', binder).getBoundingClientRect();
        var hinge = sb.left + sb.width / 2 - sp.left;
        var box = (d > 0 ? pageR : pageL).parentNode.getBoundingClientRect();
        leaf.style.left = (d > 0 ? hinge : 0) + 'px';
        leaf.style.width = (d > 0 ? sp.width - hinge : hinge) + 'px';
        var face = ' style="left:' + (box.left - sp.left - (d > 0 ? hinge : 0)).toFixed(2) + 'px;width:' + box.width.toFixed(2) + 'px"';
        var front = d > 0 ? view + 9 : view;
        var back = d > 0 ? to : to + 9;
        leaf.innerHTML =
          '<div class="llna-page llna-leaf__front ' + (d > 0 ? 'llna-page--r' : 'llna-page--l') + '"' + face + '><ol class="llna-pockets">' + pageHTML(front, 0, true) + '</ol></div>' +
          '<div class="llna-page llna-leaf__back ' + (d > 0 ? 'llna-page--l' : 'llna-page--r') + '"' + face + '><ol class="llna-pockets">' + pageHTML(back, 0, true) + '</ol></div>';
        if (d > 0) pageR.innerHTML = pageHTML(to + 9, 9, true);
        else pageL.innerHTML = pageHTML(to, 0, true);
      }
      spreadEl.appendChild(leaf);
      void leaf.offsetWidth;
      requestAnimationFrame(function () { leaf.classList.add('is-turn'); });
      /* On landing, the cards already drawn on the leaf move onto the page
         beneath it, decoded pictures and all, in the same frame the leaf goes:
         nothing is redrawn, so nothing can flicker. */
      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        var solo = leaf.classList.contains('llna-leaf--solo') || leaf.classList.contains('llna-leaf--solo-in');
        var src = solo ? (d < 0 ? $('.llna-leaf__front .llna-pockets', leaf) : null) : $('.llna-leaf__back .llna-pockets', leaf);
        var dest = solo ? pageL : (d > 0 ? pageL : pageR);
        if (src) {
          dest.textContent = '';
          while (src.firstChild) dest.appendChild(src.firstChild);
        }
        leaf.remove();
        view = to;
        turning = false;
        paintBar();
        autoTurn();
      };
      leaf.addEventListener('transitionend', function (e) { if (e.target === leaf && e.propertyName === 'transform') finish(); });
      setTimeout(finish, ms + 250);
    });
  }
  function autoTurn() {
    clearTimeout(autoT);
    if (autoOff || heroAway || hold || document.hidden || pagesTotal() < 2) return;
    autoT = setTimeout(function () { turn(1, false); }, TURN);
  }

  /* The card out of the sleeve: on a pointer that hovers, the pocket's card
     lifts and its details sit beside it, with Add. Touch goes straight to
     the product, as a tap on a card anywhere else on the shop does. */
  var peekFor = null, peekHide = 0;
  function peekHTML(it) {
    var price = it.p > 0 ? money(it.p) + (it.w > it.p ? '<s>' + money(it.w) + '</s>' : '') : 'TBC';
    return '<div class="llna-peek__tags">' + (it.tt || '') + '</div>' +
      '<p class="llna-peek__t"><a href="' + esc(it.url) + '">' + esc(it.n) + '</a></p>' +
      '<p class="llna-peek__m">' + esc([it.fromT, it.no].filter(Boolean).join(' · ')) + '</p>' +
      '<p class="llna-peek__w">' + esc(whenLong(it)) + '</p>' +
      '<div class="llna-peek__buy"><span class="llna-peek__pr">' + price + '</span>' + actionHTML(it) + '</div>';
  }
  function showPeek(pk) {
    if (!peek || !canHover) return;
    var it = byHandle[pk.getAttribute('data-h')];
    if (!it) return;
    clearTimeout(peekHide);
    if (peekFor && peekFor !== pk) peekFor.classList.remove('is-peek');
    peekFor = pk;
    pk.classList.add('is-peek');
    peek.innerHTML = peekHTML(it);
    peek.hidden = false;
    var b = binder.getBoundingClientRect(), r = pk.getBoundingClientRect();
    var w = peek.offsetWidth, h = peek.offsetHeight;
    var side = 'r', x = r.right - b.left + 16;
    if (x + w > b.width - 8) { side = 'l'; x = r.left - b.left - 16 - w; }
    var y = Math.max(8, Math.min(b.height - h - 8, r.top - b.top + r.height * 0.06));
    peek.setAttribute('data-side', side);
    peek.style.left = Math.round(x) + 'px';
    peek.style.top = Math.round(y) + 'px';
    peek.style.setProperty('--ay', Math.round(Math.min(h - 24, Math.max(14, r.top - b.top + 34 - y))) + 'px');
  }
  function hidePeek(now) {
    clearTimeout(peekHide);
    var go = function () {
      if (peek) peek.hidden = true;
      if (peekFor) peekFor.classList.remove('is-peek');
      peekFor = null;
    };
    if (now) go(); else peekHide = setTimeout(go, 260);
  }

  function bootBinder() {
    if (!binder) return;
    $$('[data-turn]').forEach(function (b) {
      b.addEventListener('click', function () { turn(Number(b.getAttribute('data-turn')), true); });
    });
    /* On the way from a card to its details, the pointer can cross the
       neighbouring card. While details are open, another card only takes
       over if the pointer rests on it for a moment, so the details stay put
       for anyone heading into them (and the bridge in the stylesheet covers
       the gap itself). */
    var peekSwitch = 0;
    binder.addEventListener('pointerover', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (peek && peek.contains(e.target)) { clearTimeout(peekHide); clearTimeout(peekSwitch); return; }
      var pk = e.target.closest ? e.target.closest('.llna-pk[data-h]') : null;
      clearTimeout(peekSwitch);
      if (pk && !turning) {
        clearTimeout(peekHide);
        var open = peek && !peek.hidden && peekFor;
        if (!open) showPeek(pk);
        else if (pk !== peekFor) peekSwitch = setTimeout(function () { showPeek(pk); }, 220);
      } else if (peek && !peek.hidden) {
        hidePeek();
      }
    });
    binder.addEventListener('pointerleave', function () { clearTimeout(peekSwitch); hidePeek(); });
    if (peek) peek.addEventListener('pointerenter', function () { clearTimeout(peekHide); clearTimeout(peekSwitch); });
    binder.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hold = true; clearTimeout(autoT); } });
    binder.addEventListener('pointerleave', function () { hold = false; autoTurn(); });
    binder.addEventListener('focusin', function () { hold = true; clearTimeout(autoT); });
    binder.addEventListener('focusout', function (e) { if (!binder.contains(e.relatedTarget)) { hold = false; autoTurn(); } });
    /* A sideways swipe turns the page on a phone. */
    var sx = 0, sy = 0, st = 0;
    binder.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; st = Date.now(); }, { passive: true });
    binder.addEventListener('touchend', function (e) {
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4 && Date.now() - st < 700) turn(dx < 0 ? 1 : -1, true);
    }, { passive: true });
    /* Off screen, the binder stops turning. Measured on scroll and when the
       tab comes back as well as by the observer, because an observer that
       first runs while the page is hidden can report the hero as away. */
    var checkAway = function () {
      if (!hero) return;
      var r = hero.getBoundingClientRect();
      var away = r.bottom < innerHeight * 0.15 || r.top > innerHeight * 0.85;
      if (away !== heroAway) { heroAway = away; hero.classList.toggle('is-away', away); autoTurn(); }
    };
    document.addEventListener('visibilitychange', function () { checkAway(); autoTurn(); if (!document.hidden) pollSoon(); });
    var awayRaf = 0;
    addEventListener('scroll', function () { if (!awayRaf) awayRaf = requestAnimationFrame(function () { awayRaf = 0; checkAway(); }); }, { passive: true });
    if ('IntersectionObserver' in window && hero) new IntersectionObserver(checkAway, { threshold: [0, 0.15] }).observe(hero);
    checkAway();
    var lastSolo = isSolo(), rz = 0;
    addEventListener('resize', function () {
      clearTimeout(rz);
      rz = setTimeout(function () {
        var solo = isSolo();
        if (solo === lastSolo || !singles.length) return;
        lastSolo = solo;
        view = Math.floor(view / perView()) * perView();
        paintView(false);
      }, 150);
    }, { passive: true });
  }
  function feedBinder() {
    if (!pageL) return;
    singles = items.filter(function (it) { return it.k === 'single' && it.i; }).slice(0, MAX_CARDS);
    var shown = $$('.llna-pk[data-h]', binder).map(function (pk) { return pk.getAttribute('data-h'); });
    var same = shown.length && shown.every(function (h, i) { return singles[i] && singles[i].h === h; });
    if (!same) paintView(true);
    else {
      /* The server drew the same cards: add the "new since your visit"
         stickers it could not know about. */
      if (sinceMs) $$('.llna-pk[data-h]', binder).forEach(function (pk) {
        var it = byHandle[pk.getAttribute('data-h')];
        if (it && it.ts > sinceMs && !$('.llna-pk__new', pk)) pk.insertAdjacentHTML('beforeend', '<span class="llna-pk__new" aria-hidden="true">' + NUT + 'New</span>');
      });
      paintBar();
    }
    autoTurn();
  }

  /* Also just in: the newest things that are not singles. */
  function alsoHTML(it) {
    var kind = it.k === 'accessory' ? 'Accessory' : it.k === 'plush' ? 'Plush & figures' : 'Sealed';
    var price = it.a ? (it.future ? 'Pre-order ' : '') + money(it.p) : 'Sold out';
    return '<li class="llna-also__i"><a class="llna-also__a" href="' + esc(it.url) + '">' +
      '<span class="llna-also__ph">' + (it.i ? '<img src="' + esc(sized(it.i, 160)) + '" alt="" width="46" height="46" loading="lazy" decoding="async">' : '') + '</span>' +
      '<span class="llna-also__t"><b>' + esc(it.n) + '</b><small>' + esc(it.fromT || kind) + ' &middot; ' + esc(price) + '</small></span></a></li>';
  }
  function paintAlso() {
    var list = $('[data-also-list]');
    var picks = items.filter(function (it) { return it.k !== 'single'; }).slice(0, 4);
    if (!picks.length) return;
    if (!list) {
      var shelf = $('.llna-shelf');
      if (!shelf) return;
      shelf.insertAdjacentHTML('beforeend', '<div class="llna-also" data-also><p class="llna-also__k">' + NUT + 'Also just in</p><ul class="llna-also__list" role="list" data-also-list></ul></div>');
      list = $('[data-also-list]');
    }
    var have = $$('.llna-also__a', list).map(function (a) { return (a.getAttribute('href') || '').split('?')[0].split('/products/').pop(); }).join('|');
    if (have !== picks.map(function (it) { return it.h; }).join('|')) list.innerHTML = picks.map(alsoHTML).join('');
  }

  /* While the page is open and on screen, ask for the newest few every
     couple of minutes; anything new is filed in at the front. */
  var pollT = 0;
  function pollSoon() { clearTimeout(pollT); pollT = setTimeout(poll, Math.max(60, Number(cfg.poll) || 120) * 1000); }
  function poll() {
    if (document.hidden || !cfg.head) { pollSoon(); return; }
    getJSON(cfg.head + '&_=' + Math.floor(Date.now() / 60000)).then(function (j) {
      refreshToday();
      var fresh = merge(j.items || [], true);
      if (!fresh.length) return;
      writeJSON(SS, CACHE, null);
      fresh.forEach(function (it) { it._fresh = true; setTimeout(function () { it._fresh = false; }, 60000); });
      singles = items.filter(function (it) { return it.k === 'single' && it.i; }).slice(0, MAX_CARDS);
      if (view === 0 && !turning) paintView(true);
      else paintBar();
      paintAlso();
      announce(fresh.length === 1 ? 'Just listed: ' + fresh[0].t : fresh.length + ' new listings');
      paintStats();
      refresh();
    }).catch(function () {}).then(pollSoon);
  }

  /* ------------------------------------------------------------- 4 numbers */
  function countUp(el, n, suffix) {
    if (!el) return;
    el.classList.remove('is-wait');
    var target = Number(n) || 0;
    var from = Number(String(el.textContent).replace(/[^\d]/g, '')) || 0;
    if (reduce || from === target) { el.textContent = target.toLocaleString('en-GB') + (suffix || ''); return; }
    var t0 = performance.now(), dur = 700;
    (function tick(t) {
      var k = Math.min(1, (t - t0) / dur);
      k = 1 - Math.pow(1 - k, 3);
      el.textContent = Math.round(from + (target - from) * k).toLocaleString('en-GB') + (k === 1 ? (suffix || '') : '');
      if (k < 1) requestAnimationFrame(tick);
    })(t0);
  }
  function paintStats() {
    if (!items.length) return;
    var top = items[0];
    var dropN = items.filter(function (it) { return it.day === top.day; }).length;
    var d = dayDiff(todayKey, top.day);
    countUp($('[data-stat="drop"]'), dropN);
    var dl = $('[data-stat-l="drop"]');
    if (dl) dl.textContent = d <= 0 ? 'listed today' : d === 1 ? 'listed yesterday' : 'listed ' + dayShort(top.day);
    var now = Date.now();
    var week = items.filter(function (it) { return now - it.ts < 7 * DAY; }).length;
    var month = items.filter(function (it) { return now - it.ts < 30 * DAY; }).length;
    countUp($('[data-stat="week"]'), week);
    countUp($('[data-stat="month"]'), month, fullSpan ? '' : '+');
    var lt = $('[data-stat="latest"]'), ll = $('[data-stat-l="latest"]');
    if (lt) lt.textContent = d <= 0 ? F_TIME.format(new Date(top.ts)) : F_DM.format(new Date(top.ts)).toUpperCase();
    if (ll) ll.textContent = d <= 0 ? 'latest listing, UK time' : 'latest listing';
  }

  /* ------------------------------------------------------------- 5 since your last visit */
  /* The first look in a session sets the line, so a reload does not wipe out
     what was new; the next visit, in a new session, measures from this one. */
  var SEEN = 'll_na_seen', PREV = 'll_na_prev';
  var sinceMs = 0;
  (function () {
    var prev = SS ? SS.getItem(PREV) : null;
    if (prev === null) {
      prev = LS ? (LS.getItem(SEEN) || '') : '';
      if (SS) try { SS.setItem(PREV, prev); } catch (e) {}
    }
    sinceMs = Number(prev) || 0;
    if (LS) try { LS.setItem(SEEN, String(Date.now())); } catch (e) {}
  })();
  function sinceList() { return sinceMs ? items.filter(function (it) { return it.ts > sinceMs; }) : []; }
  function paintSince() {
    var el = $('[data-since]');
    if (!el || !items.length) return;
    var list = sinceList();
    var when = sinceMs ? dayShort(dayKey(sinceMs)) + ', ' + F_TIME.format(new Date(sinceMs)) : '';
    var reachedBack = !fullSpan && sinceMs && sinceMs < oldestLoaded;
    if (!sinceMs) {
      el.className = 'llna-since is-first';
      el.innerHTML = '<p>' + NUT + '<span>First time on this page? It keeps a log of everything we list. Come back and it will show you what is new since now.</span></p>';
    } else if (list.length) {
      el.className = 'llna-since';
      el.innerHTML = '<p>' + NUT + '<span>Welcome back. <b>' + list.length + (reachedBack ? '+' : '') + ' new</b> since your last visit (' + esc(when) + ').</span></p>' +
        '<button type="button" class="llna-btn llna-btn--1" data-since-go>Show me what is new</button>';
    } else {
      el.className = 'llna-since is-first';
      el.innerHTML = '<p>' + NUT + '<span>You are up to date: nothing new since your last visit (' + esc(when) + '). New cards go into the binder the moment we list them.</span></p>';
    }
    el.hidden = false;
  }
  root.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-since-go]')) return;
    pickSince();
    var t = document.getElementById('llna-drops');
    if (t) t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  /* ------------------------------------------------------------- 6 the drop log */
  /* Week by week, laid out for shoppers rather than as a chart:
       - a shelf of week tiles, newest first. Each tile has the week's real
         count in big type and the first few things that landed in it, and
         "New to you" leads when something has gone up since the last visit;
       - one filter bar: search, game, type, sort, and quick toggles for in
         stock, Japanese, under £5 and on offer. The tiles count what the
         filters leave, so a search shows which week a card landed in;
       - the picked week, day by day, with a jump to each day, "complete a
         set", and Show more, which adds a page at a time.
     The week, the filters and how far down someone got are kept for the
     session, so coming back from a product page lands in the same place. */
  var weeksEl = $('[data-dl-weeks]');
  var filtersEl = $('[data-dl-filters]');
  var dayEl = $('[data-day]');
  var totalEl = $('[data-dl-drops-total]');
  var qEl = $('[data-dl-q]'), typeEl = $('[data-dl-type]'), sortEl = $('[data-dl-sort]');
  var gamesEl = $('[data-dl-games]'), togglesEl = $('[data-dl-toggles]'), clearEl = $('[data-dl-clear-f]');
  var PAGE = innerWidth < 760 ? 12 : 24;
  var STATE = 'llna_drops_v1';
  var F0 = { q: '', game: 'all', type: 'all', stock: false, ja: false, u5: false, deal: false, sort: 'new' };
  var F = Object.assign({}, F0);
  var pickedWeek = null;   // a Monday's day key, or 'since'
  var shown = PAGE;
  var runsOpen = false;
  var cur = { list: [], byDay: true, counts: {} };
  var TYPES = [['single', 'Singles'], ['sealed', 'Sealed'], ['acc', 'Accessories'], ['plush', 'Plush & figures']];
  function typeOf(it) { return it.k === 'single' ? 'single' : it.k === 'accessory' ? 'acc' : it.k === 'plush' ? 'plush' : 'sealed'; }
  /* Lower case without accents, so "pokemon" finds "Pokémon". */
  function fold(s) {
    s = String(s || '').toLowerCase();
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    return s;
  }

  var saved = readJSON(SS, STATE, null);
  if (saved && saved.F) {
    Object.keys(F0).forEach(function (k) { if (k in saved.F) F[k] = saved.F[k]; });
    pickedWeek = saved.w || null;
    shown = Math.max(PAGE, Number(saved.n) || PAGE);
  }
  function save() { writeJSON(SS, STATE, { F: F, w: pickedWeek, n: shown, y: Math.round(window.scrollY || 0) }); }
  addEventListener('pagehide', save);

  function inWindow(it) { return it.day >= windowStart(); }
  function anyFilter() { return !!(F.q || F.game !== 'all' || F.type !== 'all' || F.stock || F.ja || F.u5 || F.deal); }
  function matches(it, skip) {
    if (skip !== 'game' && F.game !== 'all' && it.game !== F.game) return false;
    if (skip !== 'type' && F.type !== 'all' && typeOf(it) !== F.type) return false;
    if (F.stock && !it.a) return false;
    if (F.ja && it.l !== 'ja') return false;
    if (F.u5 && !(it.p > 0 && it.p < 500)) return false;
    if (F.deal && !(it.w > it.p)) return false;
    if (F.q) {
      var hay = it._hay || (it._hay = fold([it.t, it.n, it.fromT, it.no].join(' ')));
      var words = F.q.split(' ');
      for (var i = 0; i < words.length; i++) if (words[i] && hay.indexOf(words[i]) < 0) return false;
    }
    return true;
  }
  /* The weeks on show, newest first. */
  function weekKeys() {
    var keys = [];
    for (var i = 0; i < WEEKS; i++) keys.push(addDays(weekOf(todayKey), -7 * i));
    return keys;
  }
  /* "13–19 Oct", or "29 Sept–5 Oct" across a month end. */
  function weekRange(mon) {
    var sun = addDays(mon, 6);
    var a = F_DM.format(new Date(keyMs(mon))), b = F_DM.format(new Date(keyMs(sun)));
    var am = a.replace(/^\d+\s*/, ''), bm = b.replace(/^\d+\s*/, '');
    return am === bm ? Number(mon.slice(8)) + '–' + b : a + '–' + b;
  }
  function weekName(mon) {
    var ago = Math.round(dayDiff(weekOf(todayKey), mon) / 7);
    if (ago <= 0) return 'This week';
    if (ago === 1) return 'Last week';
    return 'Week of ' + F_DML.format(new Date(keyMs(mon)));
  }
  function dayLabel(k) {
    var dd = dayDiff(todayKey, k);
    return dd <= 0 ? 'Today' : dd === 1 ? 'Yesterday' : F_WDL.format(new Date(keyMs(k)));
  }
  function dayJumpLabel(k) {
    var dd = dayDiff(todayKey, k);
    return dd <= 0 ? 'Today' : dd === 1 ? 'Yesterday' : dayShort(k);
  }

  /* -- the filter bar -- */
  function paintFilters() {
    if (!filtersEl) return;
    var win = items.filter(inWindow);
    if (gamesEl) {
      var forGame = win.filter(function (it) { return matches(it, 'game'); });
      var gc = {};
      forGame.forEach(function (it) { gc[it.game] = (gc[it.game] || 0) + 1; });
      var games = GAMES.filter(function (g) { return gc[g[0]] || F.game === g[0]; });
      gamesEl.hidden = games.length < 2 && F.game === 'all';
      gamesEl.innerHTML = '<button type="button" class="llna-chip" data-dl-game="all" aria-pressed="' + (F.game === 'all') + '">All games <small>' + forGame.length + '</small></button>' +
        games.map(function (g) {
          return '<button type="button" class="llna-chip" data-dl-game="' + g[0] + '" aria-pressed="' + (F.game === g[0]) + '">' + esc(g[1]) + ' <small>' + (gc[g[0]] || 0) + '</small></button>';
        }).join('');
    }
    if (typeEl) {
      var forType = win.filter(function (it) { return matches(it, 'type'); });
      var tc = {};
      forType.forEach(function (it) { var t = typeOf(it); tc[t] = (tc[t] || 0) + 1; });
      typeEl.innerHTML = '<option value="all">All types (' + forType.length + ')</option>' +
        TYPES.filter(function (t) { return tc[t[0]] || F.type === t[0]; }).map(function (t) {
          return '<option value="' + t[0] + '">' + esc(t[1]) + ' (' + (tc[t[0]] || 0) + ')</option>';
        }).join('');
      typeEl.value = F.type;
    }
    if (sortEl) sortEl.value = F.sort;
    if (qEl && document.activeElement !== qEl) qEl.value = F.q;
    $$('[data-dl-tog]', togglesEl || filtersEl).forEach(function (b) { b.setAttribute('aria-pressed', F[b.getAttribute('data-dl-tog')] ? 'true' : 'false'); });
    if (clearEl) clearEl.hidden = !anyFilter();
  }

  /* -- the week tiles -- */
  function tileHTML(k, name, range, list) {
    var n = list.length, sel = pickedWeek === k;
    var pics = list.filter(function (it) { return it.i; }).slice(0, 3).map(function (it) {
      return '<img src="' + esc(sized(it.i, 120)) + '" alt="" loading="lazy" decoding="async">';
    }).join('');
    return '<button type="button" role="tab" id="llna-wk-' + k + '" class="llna-wk' + (k === 'since' ? ' llna-wk--since' : '') + (n ? '' : ' is-zero') + '"' +
      ' data-dl-week="' + k + '" aria-selected="' + sel + '" aria-controls="llna-week" tabindex="' + (sel ? 0 : -1) + '"' +
      ' aria-label="' + esc(name + ', ' + range + ', ' + (n ? n + ' listed' : 'nothing listed')) + '">' +
      '<span class="llna-wk__name">' + (k === 'since' ? NUT : '') + esc(name) + '</span>' +
      '<span class="llna-wk__range">' + esc(range) + '</span>' +
      '<span class="llna-wk__n">' + n.toLocaleString('en-GB') + '</span>' +
      '<span class="llna-wk__l">' + (n ? 'listed' : (anyFilter() ? 'none match' : 'nothing yet')) + '</span>' +
      '<span class="llna-wk__pics" aria-hidden="true">' + pics + '</span>' +
    '</button>';
  }
  function paintWeeks() {
    if (!weeksEl || !items.length) return;
    var keys = weekKeys();
    var per = {}, total = 0;
    keys.forEach(function (k) { per[k] = []; });
    items.forEach(function (it) { if (per[it.week] && matches(it)) { per[it.week].push(it); total++; } });
    var since = sinceList();
    if (pickedWeek === 'since' && !since.length) pickedWeek = null;
    if (pickedWeek && pickedWeek !== 'since' && keys.indexOf(pickedWeek) < 0) pickedWeek = null;
    if (!pickedWeek) {
      for (var i = 0; i < keys.length; i++) if (per[keys[i]].length) { pickedWeek = keys[i]; break; }
      if (!pickedWeek) pickedWeek = keys[0];
    }
    var html = [];
    if (since.length) html.push(tileHTML('since', 'New to you', 'Since ' + dayShort(dayKey(sinceMs)), since.filter(function (it) { return matches(it); })));
    keys.forEach(function (k, j) {
      html.push(tileHTML(k, j === 0 ? 'This week' : j === 1 ? 'Last week' : j + ' weeks ago', weekRange(k), per[k]));
    });
    weeksEl.innerHTML = html.join('');
    if (totalEl) {
      totalEl.innerHTML = '<b>' + total.toLocaleString('en-GB') + (fullSpan ? '' : '+') + '</b>' +
        '<span>' + (anyFilter() ? 'match in the last ' : 'listed in the last ') + WEEKS + ' weeks</span>';
    }
    /* keep the picked tile in view where the shelf scrolls sideways */
    var sel = weeksEl.querySelector('[aria-selected="true"]');
    if (sel && weeksEl.scrollWidth > weeksEl.clientWidth + 4) {
      var left = sel.offsetLeft, right = left + sel.offsetWidth;
      if (left < weeksEl.scrollLeft || right > weeksEl.scrollLeft + weeksEl.clientWidth) weeksEl.scrollLeft = Math.max(0, left - 16);
    }
  }

  /* -- the picked week -- */
  function weekBase() {
    if (pickedWeek === 'since') return sinceList();
    return items.filter(function (it) { return it.week === pickedWeek; });
  }
  function sorted(list) {
    if (F.sort === 'new') return list;   // the feed is newest first already
    var low = F.sort === 'low';
    return list.slice().sort(function (a, b) {
      if (!!a.a !== !!b.a) return a.a ? -1 : 1;           // in stock first
      var pa = a.p > 0 ? a.p : (low ? Infinity : -1), pb = b.p > 0 ? b.p : (low ? Infinity : -1);
      return low ? pa - pb : pb - pa;
    });
  }
  function dayHead(k, n) {
    var dd = dayDiff(todayKey, k);
    var sub = dd <= 1 ? dayTitle(k) : F_DML.format(new Date(keyMs(k)));
    return '<h4 class="llna-dayh" id="llna-d-' + k + '"><b>' + esc(dayLabel(k)) + '</b><span>' + esc(sub) + '</span><small>' + n + ' listed</small></h4>';
  }
  function cellsFor(from, to) {
    var out = [], last = from > 0 ? cur.list[from - 1].day : '';
    for (var i = from; i < to; i++) {
      var it = cur.list[i];
      if (cur.byDay && it.day !== last) { last = it.day; out.push(dayHead(it.day, cur.counts[it.day])); }
      out.push(card(it, { i: i - from, since: true }));
    }
    return out.join('');
  }
  function moreHTML() {
    var left = cur.list.length - shown;
    if (left > 0) {
      return '<div class="llna-day__more" data-dl-more-box><button type="button" class="llna-btn llna-btn--2 llna-day__all" data-dl-more>Show ' + Math.min(PAGE, left) + ' more <small>' + left + ' to go</small></button></div>';
    }
    return cur.list.length > PAGE ? '<div class="llna-day__more" data-dl-more-box><p class="llna-day__end">' + NUT + 'That is everything ' + (pickedWeek === 'since' ? 'since your visit' : 'from this week') + '.</p></div>' : '<div data-dl-more-box></div>';
  }
  function paintWeek() {
    if (!dayEl || !pickedWeek) return;
    var isSince = pickedWeek === 'since';
    var base = weekBase();
    var list = sorted(base.filter(function (it) { return matches(it); }));
    var title = isSince ? 'New to you' : weekName(pickedWeek);
    var badge = isSince ? 'Since ' + dayShort(dayKey(sinceMs)) : weekRange(pickedWeek);
    dayEl.setAttribute('aria-labelledby', 'llna-wk-' + pickedWeek);
    var head = '<div class="llna-wkhead"><h3 class="llna-day__t">' + esc(title) + '<span class="llna-day__badge">' + esc(badge) + '</span></h3>';
    if (!base.length) {
      cur = { list: [], byDay: true, counts: {} };
      dayEl.innerHTML = head + '</div><div class="llna-empty"><b>Nothing listed yet</b>' +
        (pickedWeek === weekOf(todayKey) ? 'The week has only just started. New listings show up here the moment they go on the shelf.' : 'Nothing went on the shelf this week.') + '</div>';
      return;
    }
    if (!list.length) {
      cur = { list: [], byDay: true, counts: {} };
      dayEl.innerHTML = head + '</div><div class="llna-empty"><b>Nothing here matches</b>' +
        base.length + ' listed ' + (isSince ? 'since your visit' : 'this week') + ', but none fit your filters.' +
        '<button type="button" class="llna-btn llna-btn--2" data-dl-clear-f>Clear filters</button></div>';
      return;
    }
    if (shown > list.length) shown = Math.max(PAGE, list.length);
    var inStock = list.filter(function (it) { return it.a; });
    var priced = inStock.filter(function (it) { return it.p > 0; }).map(function (it) { return it.p; });
    var kinds = {}, ja = 0;
    list.forEach(function (it) { kinds[it.k] = (kinds[it.k] || 0) + 1; if (it.l === 'ja') ja++; });
    var mix = [];
    if (kinds.single) mix.push(kinds.single + (kinds.single === 1 ? ' single' : ' singles'));
    if (kinds.sealed || kinds.other) mix.push(((kinds.sealed || 0) + (kinds.other || 0)) + ' sealed');
    if (kinds.accessory) mix.push(kinds.accessory + (kinds.accessory === 1 ? ' accessory' : ' accessories'));
    if (kinds.plush) mix.push(kinds.plush + ' plush & figures');
    if (ja && ja < list.length) mix.push(ja + ' Japanese');
    else if (ja) mix.push('all Japanese');
    var facts = '<p class="llna-day__facts"><b>' + list.length + '</b> ' + (anyFilter() ? 'match' : 'listed') + ' &middot; <b>' + inStock.length + '</b> in stock' +
      (priced.length ? ' &middot; from <b>' + money(Math.min.apply(null, priced)) + '</b>' : '') +
      (mix.length ? ' &middot; ' + esc(mix.join(', ')) : '') + '</p>';

    /* Complete a set: two or more new singles from one set, in stock. Folded
       away until asked for, then a picker that shows exactly which cards go
       in: each one can be left out, and the button says how many and how much. */
    var sets = {};
    inStock.forEach(function (it) {
      if (it.k !== 'single' || it.vn > 1 || !it.f || it.p <= 0) return;
      var key = it.f.toUpperCase();
      (sets[key] = sets[key] || []).push(it);
    });
    currentRuns = Object.keys(sets).map(function (k) { return sets[k]; }).filter(function (r) { return r.length >= 2; })
      .sort(function (a, b) { return b.length - a.length; }).slice(0, 10);
    var runsHTML = currentRuns.length
      ? '<details class="llna-runs" data-runs-box' + (runsOpen ? ' open' : '') + '><summary class="llna-runs__s">' + NUT +
          '<b>Complete a set</b><span>' + (currentRuns.length === 1 ? esc(currentRuns[0][0].fromT) + ' has ' + currentRuns[0].length + ' new cards here' : currentRuns.length + ' sets have two or more new cards here') + '</span>' +
          '<i class="llna-runs__chev" aria-hidden="true"></i></summary><div data-runs>' + runsInner() + '</div></details>'
      : '';

    var byDay = F.sort === 'new';
    var counts = {}, order = [];
    list.forEach(function (it) { if (!counts[it.day]) { counts[it.day] = 0; order.push(it.day); } counts[it.day]++; });
    cur = { list: list, byDay: byDay, counts: counts };
    var jump = byDay && order.length > 1
      ? '<nav class="llna-jumpdays" aria-label="Jump to a day">' + order.map(function (k) {
          return '<button type="button" class="llna-chip llna-chip--sm" data-dl-jump="' + k + '">' + esc(dayJumpLabel(k)) + ' <small>' + counts[k] + '</small></button>';
        }).join('') + '</nav>'
      : '';
    dayEl.innerHTML = head + facts + '</div>' + runsHTML + jump +
      '<div class="llna-grid" data-dl-week-grid>' + cellsFor(0, Math.min(shown, list.length)) + '</div>' + moreHTML();
  }
  function showMore() {
    var grid = $('[data-dl-week-grid]', dayEl);
    if (!grid) return;
    var from = shown;
    shown = Math.min(cur.list.length, shown + PAGE);
    grid.insertAdjacentHTML('beforeend', cellsFor(from, shown));
    var box = $('[data-dl-more-box]', dayEl);
    if (box) box.outerHTML = moreHTML();
    /* move keyboard focus to the first card that just arrived */
    var firstNew = grid.querySelectorAll('.llna-card')[from];
    var link = firstNew && firstNew.querySelector('.llna-card__t a');
    if (link) try { link.focus({ preventScroll: true }); } catch (e) {}
    save();
  }
  function jumpTo(k) {
    var idx = -1;
    for (var i = 0; i < cur.list.length; i++) if (cur.list[i].day === k) { idx = i; break; }
    if (idx < 0) return;
    if (idx >= shown) { shown = Math.min(cur.list.length, idx + PAGE); paintWeek(); }
    var h = document.getElementById('llna-d-' + k);
    if (h) h.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    save();
  }
  function refresh() { paintFilters(); paintWeeks(); paintWeek(); save(); }
  function pickWeek(k) {
    pickedWeek = k;
    shown = PAGE;
    paintWeeks();
    paintWeek();
    save();
  }
  function pickSince() { if (sinceList().length) pickWeek('since'); }

  if (weeksEl) {
    weeksEl.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-dl-week]') : null;
      if (b) pickWeek(b.getAttribute('data-dl-week'));
    });
    weeksEl.addEventListener('keydown', function (e) {
      if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(e.key) < 0) return;
      var tabs = $$('[data-dl-week]', weeksEl), i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      var j = e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : Math.max(0, Math.min(tabs.length - 1, i + (e.key === 'ArrowRight' ? 1 : -1)));
      var k = tabs[j].getAttribute('data-dl-week');
      pickWeek(k);
      var t = weeksEl.querySelector('[data-dl-week="' + k + '"]');
      if (t) t.focus();
    });
  }
  /* After a repaint, put focus back on the control that was used. */
  function refocus(sel) { var el = filtersEl && filtersEl.querySelector(sel); if (el) try { el.focus({ preventScroll: true }); } catch (e) {} }
  var qT = null;
  if (qEl) qEl.addEventListener('input', function () {
    clearTimeout(qT);
    qT = setTimeout(function () { F.q = fold(qEl.value).replace(/\s+/g, ' ').trim(); shown = PAGE; refresh(); }, 160);
  });
  if (filtersEl) {
    filtersEl.addEventListener('submit', function (e) { e.preventDefault(); });
    filtersEl.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var g = e.target.closest('[data-dl-game]');
      if (g) { F.game = g.getAttribute('data-dl-game'); shown = PAGE; refresh(); refocus('[data-dl-game="' + F.game + '"]'); return; }
      var t = e.target.closest('[data-dl-tog]');
      if (t) { var k = t.getAttribute('data-dl-tog'); F[k] = !F[k]; shown = PAGE; refresh(); refocus('[data-dl-tog="' + k + '"]'); }
    });
    filtersEl.addEventListener('change', function (e) {
      if (e.target === typeEl) { F.type = typeEl.value; shown = PAGE; refresh(); }
      else if (e.target === sortEl) { F.sort = sortEl.value; shown = PAGE; refresh(); }
    });
  }
  /* Clear filters, from the filter bar or from an empty week. Sort stays. */
  root.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-dl-clear-f]')) return;
    var sort = F.sort;
    F = Object.assign({}, F0);
    F.sort = sort;
    if (qEl) qEl.value = '';
    shown = PAGE;
    refresh();
  });

  var currentRuns = [];   // the set runs in the week on show
  var runKey = '';        // which run is open (its set name)
  var runOff = {};        // variant ids left out by the shopper
  var TICK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9.5 16.6 5.4 12.5 4 13.9l5.5 5.5L20 8.9l-1.4-1.4z"/></svg>';
  function runsInner() {
    if (!currentRuns.length) return '';
    var sel = 0;
    currentRuns.forEach(function (r, i) { if (r[0].f.toUpperCase() === runKey) sel = i; });
    runKey = currentRuns[sel][0].f.toUpperCase();
    var run = currentRuns[sel];
    var picked = run.filter(function (it) { return !inCart[it.v] && !runOff[it.v]; });
    var total = picked.reduce(function (t, it) { return t + it.p; }, 0);
    var allIn = run.every(function (it) { return inCart[it.v]; });
    var inBasket = run.filter(function (it) { return inCart[it.v]; }).length;
    var tabs = currentRuns.length > 1 ? '<div class="llna-runs__tabs" role="group" aria-label="Sets">' + currentRuns.map(function (r, i) {
      return '<button type="button" class="llna-runs__tab" data-run-tab="' + i + '" aria-pressed="' + (i === sel) + '">' + esc(r[0].fromT) + ' <small>' + r.length + '</small></button>';
    }).join('') + '</div>' : '';
    var cards = run.map(function (it) {
      var inB = !!inCart[it.v], on = !inB && !runOff[it.v];
      return '<li><button type="button" class="llna-rc' + (on ? ' is-on' : '') + (inB ? ' is-in' : '') + '" data-run-card="' + it.v + '" aria-pressed="' + on + '"' + (inB ? ' disabled' : '') +
        ' aria-label="' + esc(it.t) + ', ' + money(it.p) + (inB ? ', already in your basket' : on ? ', included' : ', left out') + '">' +
        '<span class="llna-rc__ph">' + (it.i ? '<img src="' + esc(sized(it.i, 220)) + '" alt="" loading="lazy" decoding="async">' : '') +
          '<span class="llna-rc__tick" aria-hidden="true">' + TICK + '</span></span>' +
        '<span class="llna-rc__t">' + esc(it.n) + '</span>' +
        '<span class="llna-rc__m">' + esc(it.no || it.fromT) + '</span>' +
        '<span class="llna-rc__p">' + (inB ? 'In basket' : money(it.p)) + '</span>' +
      '</button></li>';
    }).join('');
    var ids = picked.map(function (it) { return it.v; }).join(',');
    var name = run[0].fromT;
    return '<p class="llna-runs__note">Every new card from one set in this week. Tap a card to leave it out.</p>' + tabs +
      '<ul class="llna-runs__cards" role="list" aria-label="' + esc(name) + ' cards">' + cards + '</ul>' +
      '<div class="llna-runs__foot">' +
        '<p class="llna-runs__sum">' + (allIn
          ? 'All ' + run.length + ' ' + esc(name) + ' cards are in your basket.'
          : picked.length
            ? '<b>' + picked.length + ' of ' + run.length + '</b> ' + esc(name) + ' cards &middot; <b>' + money(total) + '</b>' + (inBasket ? ' &middot; ' + inBasket + ' already in your basket' : '')
            : '<b>' + inBasket + ' of ' + run.length + '</b> in your basket' + (run.length - inBasket ? ' &middot; ' + (run.length - inBasket) + ' left out' : '')) + '</p>' +
        (allIn ? '<a class="llna-btn llna-btn--2" href="' + esc(cfg.cart || '/cart') + '">View basket</a>'
          : '<button type="button" class="llna-btn llna-btn--1" data-run="' + ids + '" data-run-name="' + esc(name) + '"' + (picked.length ? '' : ' disabled') + '>' + NUT +
            (picked.length ? 'Add ' + picked.length + ' to basket &middot; ' + money(total) : 'Pick a card to add') + '</button>') +
      '</div>';
  }
  function paintRuns() {
    var box = dayEl && $('[data-runs]', dayEl);
    if (!box) return;
    var sx = $('.llna-runs__cards', box);
    var keep = sx ? sx.scrollLeft : 0;
    box.innerHTML = runsInner();
    sx = $('.llna-runs__cards', box);
    if (sx) sx.scrollLeft = keep;
  }

  if (dayEl) {
    dayEl.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var tab = e.target.closest('[data-run-tab]');
      if (tab) {
        var r = currentRuns[Number(tab.getAttribute('data-run-tab'))];
        if (r) { runKey = r[0].f.toUpperCase(); paintRuns(); }
        return;
      }
      var rc = e.target.closest('[data-run-card]');
      if (rc && !rc.disabled) {
        var v = rc.getAttribute('data-run-card');
        if (runOff[v]) delete runOff[v]; else runOff[v] = true;
        paintRuns();
        var again = dayEl.querySelector('[data-run-card="' + v + '"]');
        if (again) again.focus();
        return;
      }
      if (e.target.closest('[data-dl-more]')) { showMore(); return; }
      var j = e.target.closest('[data-dl-jump]');
      if (j) jumpTo(j.getAttribute('data-dl-jump'));
    });
    /* toggle does not bubble, so listen on the way down */
    dayEl.addEventListener('toggle', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-runs-box')) runsOpen = e.target.open;
    }, true);
  }

  /* ------------------------------------------------------------- 7 cards */
  var inCart = {};
  function actionHTML(it, big) {
    var cls = big ? 'llna-btn llna-btn--1' : 'llna-add';
    if (inCart[it.v]) return '<a class="' + (big ? 'llna-btn llna-btn--3' : 'llna-add is-in') + '" href="' + esc(cfg.cart || '/cart') + '">' + (big ? NUT : '') + '<span>In basket</span></a>';
    if (it.a && it.vn > 1) return '<a class="' + (big ? 'llna-btn llna-btn--3' : 'llna-add llna-add--ghost') + '" href="' + esc(it.url) + '"><span>Options</span></a>';
    if (it.a && it.v) {
      var label = it.future ? 'Pre-order' : 'Add';
      return '<button type="button" class="' + cls + '" data-add="' + it.v + '" aria-label="' + esc((it.future ? 'Pre-order ' : 'Add ') + it.t + ' to your basket') + '">' + (big ? NUT : BASKET) + '<span>' + (big ? (it.future ? 'Pre-order' : 'Add to basket') : label) + '</span></button>';
    }
    var on = watchList().indexOf(it.h) > -1;
    return '<button type="button" class="' + (big ? 'llna-btn llna-btn--3' : 'llna-add llna-add--ghost') + '" data-watch="' + esc(it.h) + '" aria-pressed="' + on + '" aria-label="' + esc((on ? 'Stop watching ' : 'Watch ') + it.t) + '">' + NUT + '<span>' + (on ? 'Watching' : 'Watch') + '</span></button>';
  }
  function card(it, o) {
    o = o || {};
    var img = it.i
      ? '<img src="' + esc(sized(it.i, 300)) + '" srcset="' + esc(sized(it.i, 200)) + ' 200w, ' + esc(sized(it.i, 300)) + ' 300w, ' + esc(sized(it.i, 400)) + ' 400w" sizes="(max-width: 760px) 45vw, 220px" alt=""" loading="lazy" decoding="async">'
      : '';
    var corner = '';
    if (o.since && sinceMs && it.ts > sinceMs) corner = '<span class="llna-card__new">' + NUT + 'New to you</span>';
    else if (o.deal && it.pct >= 5) corner = '<span class="llna-card__off">&minus;' + it.pct + '%</span>';
    var when = o.when === false ? '' : '<span class="llna-card__when">' + esc(o.whenText || whenWord(it)) + '</span>';
    var meta = [it.fromT, it.no].filter(Boolean).join(' · ');
    var price = it.p > 0
      ? money(it.p) + (it.w > it.p ? '<s>' + money(it.w) + '</s>' : '') + (o.deal && it.off ? '<small>Save ' + money(it.off) + '</small>' : '')
      : '<span>Price to come</span>';
    return '<article class="llna-card" data-h="' + esc(it.h) + '" style="--i:' + (o.i || 0) + '">' +
      '<a class="llna-card__ph" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + img +
        (it.tt ? '<span class="llna-card__tags">' + it.tt + '</span>' : '') + corner + when + '</a>' +
      '<div class="llna-card__bd">' +
        (meta ? '<p class="llna-card__m">' + esc(meta) + '</p>' : '') +
        '<h3 class="llna-card__t"><a href="' + esc(it.url) + '">' + esc(it.n) + '</a></h3>' +
        '<div class="llna-card__buy"><p class="llna-card__pr">' + price + '</p>' + actionHTML(it) + '</div>' +
      '</div></article>';
  }

  /* ------------------------------------------------------------- 10 the basket */
  var cart = null;
  var haul = null;
  function cartJSON() {
    return fetch((cfg.cart || '/cart') + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cart = c;
        inCart = {};
        (c.items || []).forEach(function (l) { inCart[l.variant_id] = (inCart[l.variant_id] || 0) + l.quantity; });
        paintHaul();
        return c;
      });
  }
  function broadcast(c) {
    $$('[data-cart-count], .cart-count, .cart-link__count', document).forEach(function (el) { el.textContent = c.item_count; });
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: c, bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('ll:cart:updated', { detail: c }));
    } catch (e) {}
  }
  function post(items) {
    return fetch((cfg.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, d: d }; });
    });
  }
  /* Add a list of lines. If Shopify refuses the lot (one line sold out or at
     its limit), the lines go in one at a time so the rest still land. */
  function addLines(lines) {
    return post(lines).then(function (res) {
      if (res.ok) return { added: lines.length, failed: [] };
      if (lines.length === 1) return { added: 0, failed: [res.d && (res.d.description || res.d.message) || 'That could not be added.'] };
      var added = 0, failed = [];
      return lines.reduce(function (p, line) {
        return p.then(function () {
          return post([line]).then(function (r) {
            if (r.ok) added++;
            else failed.push(r.d && (r.d.description || r.d.message) || 'One item could not be added.');
          });
        });
      }, Promise.resolve()).then(function () { return { added: added, failed: failed }; });
    });
  }
  function addAndReport(lines, btn, name) {
    if (!lines.length || (btn && btn.getAttribute('aria-busy') === 'true')) return Promise.resolve();
    if (btn) btn.setAttribute('aria-busy', 'true');
    return addLines(lines).then(function (r) {
      return cartJSON().then(function (c) {
        broadcast(c);
        if (btn) btn.removeAttribute('aria-busy');
        repaintActions();
        if (r.added) {
          showHaul(true);
          var msg = r.failed.length ? 'Added ' + r.added + ' of ' + lines.length + '. ' + r.failed[0] : (name ? name + ' added to your basket' : 'Added to your basket');
          say(msg, cfg.cart || '/cart', 'View basket');
        } else {
          say(r.failed[0] || 'Sorry, that could not be added to your basket.');
        }
        return r;
      });
    }).catch(function () {
      if (btn) btn.removeAttribute('aria-busy');
      say('We could not reach the basket. Check your connection and try again.');
    });
  }
  /* Every add button on the page redraws from the basket, so a card that is
     in it says so wherever it appears. */
  function repaintActions() {
    $$('.llna-card', root).forEach(function (c) {
      var it = byHandle[c.getAttribute('data-h')];
      if (!it) return;
      var buy = $('.llna-card__buy', c);
      if (!buy) return;
      var cur = buy.lastElementChild;
      var tmp = document.createElement('div');
      tmp.innerHTML = actionHTML(it);
      if (cur && tmp.firstElementChild && cur.outerHTML !== tmp.firstElementChild.outerHTML) cur.replaceWith(tmp.firstElementChild);
    });
    if (peekFor && peek && !peek.hidden) showPeek(peekFor);
    paintRuns();
  }
  root.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var b = e.target.closest('[data-add]');
    if (b) {
      e.preventDefault();
      var it = byVariant[b.getAttribute('data-add')];
      addAndReport([{ id: Number(b.getAttribute('data-add')), quantity: 1 }], b, it ? it.n : '');
      return;
    }
    var run = e.target.closest('[data-run]');
    if (run) {
      var ids = run.getAttribute('data-run').split(',').filter(function (id) { return !inCart[id]; });
      addAndReport(ids.map(function (id) { return { id: Number(id), quantity: 1 }; }), run, (ids.length === 1 ? '1 card' : ids.length + ' cards') + ' from ' + run.getAttribute('data-run-name'));
      return;
    }
  });

  /* The basket bar: what is in the basket, how far to free delivery, and, if
     there are singles in it and no protection, a one tap offer of sleeves
     and toploaders. It appears after something is added here. */
  var HAUL_X = 'll_na_haul_x';
  function liftHaul() {
    var lift = 0;
    $$('nav.llmt, [data-mobile-tabbar]', document).forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return;
      var r = el.getBoundingClientRect();
      if (r.height > 8 && r.bottom >= innerHeight - 2) lift = Math.max(lift, Math.round(r.height));
    });
    document.documentElement.style.setProperty('--llna-lift', lift + 'px');
  }
  function publishHaul() {
    var up = haul && haul.classList.contains('is-up');
    var h = up ? haul.offsetHeight + 14 : 0;
    document.documentElement.style.setProperty('--llna-haul-h', h + 'px');
    document.documentElement.style.setProperty('--ll-pdpbar-h', up ? h + 'px' : '0px');
  }
  function buildHaul() {
    haul = document.createElement('div');
    haul.className = 'llna-haul llna-fixed';
    haul.setAttribute('role', 'region');
    haul.setAttribute('aria-label', 'Your basket');
    haul.innerHTML =
      '<div class="llna-haul__pics" data-haul-pics aria-hidden="true"></div>' +
      '<div class="llna-haul__mid"><p class="llna-haul__t" data-haul-t></p><div class="llna-haul__bar" aria-hidden="true"><i data-haul-fill></i></div></div>' +
      '<div class="llna-haul__act">' +
        '<button type="button" class="llna-btn llna-btn--3 llna-protect" data-haul-protect hidden></button>' +
        '<a class="llna-btn llna-btn--1" href="' + esc(cfg.cart || '/cart') + '">Basket <span aria-hidden="true">&rarr;</span></a>' +
        '<button type="button" class="llna-haul__x" data-haul-x aria-label="Hide the basket bar">&times;</button>' +
      '</div>';
    document.body.appendChild(haul);
    haul.addEventListener('click', function (e) {
      if (e.target.closest('[data-haul-x]')) {
        haul.classList.remove('is-up');
        if (SS) try { SS.setItem(HAUL_X, '1'); } catch (x) {}
        publishHaul();
        return;
      }
      var p = e.target.closest('[data-haul-protect]');
      if (p) {
        var lines = (cfg.protect || []).filter(function (x) { return !inCart[x.id]; }).map(function (x) { return { id: x.id, quantity: 1 }; });
        addAndReport(lines, p, 'Sleeves and toploaders');
      }
    });
    liftHaul();
    addEventListener('resize', function () { liftHaul(); publishHaul(); }, { passive: true });
  }
  function showHaul(force) {
    if (!cart || !cart.item_count) return;
    if (!force && SS && SS.getItem(HAUL_X)) return;
    if (force && SS) try { SS.removeItem(HAUL_X); } catch (x) {}
    if (!haul) buildHaul();
    paintHaul();
    requestAnimationFrame(function () { haul.classList.add('is-up'); publishHaul(); });
  }
  function paintHaul() {
    if (!haul || !cart) return;
    var total = cart.total_price, left = Math.max(0, FREE - total);
    var pics = (cart.items || []).slice(0, 3).map(function (l) {
      return l.image ? '<span><img src="' + esc(sized(l.image, 120)) + '" alt="" width="34" height="42" loading="lazy"></span>' : '';
    }).join('');
    $('[data-haul-pics]', haul).innerHTML = pics;
    $('[data-haul-t]', haul).innerHTML = '<b>' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + '</b> &middot; ' + money(total) +
      (left > 0 ? ' &middot; ' + money(left) + ' to free UK delivery' : ' &middot; free UK delivery unlocked');
    $('[data-haul-fill]', haul).style.width = Math.min(100, Math.round(total / FREE * 100)) + '%';
    haul.classList.toggle('is-free', left <= 0);
    var protect = $('[data-haul-protect]', haul);
    var singles = (cart.items || []).some(function (l) { var it = byVariant[l.variant_id]; return it ? it.k === 'single' : /single/i.test(l.product_type || ''); });
    var offer = (cfg.protect || []).filter(function (x) { return !inCart[x.id]; });
    var has = (cfg.protect || []).some(function (x) { return inCart[x.id]; });
    if (protect) {
      var show = singles && offer.length && !has;
      protect.hidden = !show;
      if (show) {
        var sum = offer.reduce(function (s, x) { return s + x.p; }, 0);
        protect.innerHTML = NUT + 'Protect them &middot; ' + money(sum);
        protect.setAttribute('aria-label', 'Add ' + offer.map(function (x) { return x.n; }).join(' and ') + ' for ' + money(sum));
      }
    }
    publishHaul();
  }

  /* ------------------------------------------------------------- 11 watchlist */
  var WK = 'll_watchlist', WOLD = 'll_preorder_watch', WSNAP = 'll_watchlist_snap';
  var isArr = function (v) { return Object.prototype.toString.call(v) === '[object Array]'; };
  function writeWatch(l) {
    var clean = (l || []).slice(0, 100);
    writeJSON(LS, WK, clean);
    writeJSON(LS, WOLD, clean);
    if (cfg.customer) writeJSON(LS, 'll_watchlist_c_' + cfg.customer, clean);
    try { document.dispatchEvent(new CustomEvent('ll:watchlist:change', { detail: { list: clean } })); } catch (e) {}
    return clean;
  }
  function watchList() {
    var l = readJSON(LS, WK, null);
    if (isArr(l)) return l;
    var old = readJSON(LS, WOLD, []);
    if (isArr(old) && old.length) { writeWatch(old); return old; }
    return [];
  }
  function paintWatch() {
    var l = watchList();
    $$('[data-watch]', root).forEach(function (b) {
      var on = l.indexOf(b.getAttribute('data-watch')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var s = b.querySelector('span');
      if (s) s.textContent = on ? 'Watching' : 'Watch';
    });
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-watch]') : null;
    if (!b) return;
    var h = b.getAttribute('data-watch'), l = watchList(), i = l.indexOf(h);
    if (i > -1) {
      l.splice(i, 1);
      writeWatch(l);
      var snaps = readJSON(LS, WSNAP, {});
      if (snaps && typeof snaps === 'object') { delete snaps[h]; writeJSON(LS, WSNAP, snaps); }
      if (window.LLWatchlistLive && typeof window.LLWatchlistLive.stop === 'function') window.LLWatchlistLive.stop(h);
      say('Removed from your watchlist', cfg.watch, 'View watchlist');
    } else {
      l.unshift(h);
      writeWatch(l);
      say('Saved to your watchlist', cfg.watch, 'View watchlist');
    }
    paintWatch();
  });
  document.addEventListener('ll:watchlist:change', paintWatch);

  /* ------------------------------------------------------------- 12 toasts, rails, boot */
  var toast = $('[data-toast]'), toastT, liveEl = $('[data-live]');
  if (toast) { document.body.appendChild(toast); toast.classList.add('llna-fixed', 'llna-toast'); }
  function announce(msg) { if (liveEl) liveEl.textContent = msg; }
  function say(msg, href, label) {
    announce(msg);
    if (!toast) return;
    $('[data-toast-t]', toast).textContent = msg;
    var a = $('[data-toast-a]', toast);
    if (href) { a.href = href; a.textContent = label; a.hidden = false; } else a.hidden = true;
    toast.hidden = false;
    void toast.offsetWidth;
    toast.classList.add('on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toast.classList.remove('on'); }, 4200);
  }

  function failSoft() {
    /* Without the feed the binder keeps the server's first spread and the rest says
       so plainly, rather than leaving skeletons spinning. */
    $$('.llna-skel', root).forEach(function (s) { s.remove(); });
    if (dayEl) dayEl.innerHTML = '<div class="llna-empty"><b>The drop log did not load</b>Everything is still in the full list below.</div>';
    if (weeksEl) weeksEl.hidden = true;
    if (filtersEl) filtersEl.hidden = true;
    if (totalEl) totalEl.hidden = true;
    $$('.llna-stat b.is-wait', root).forEach(function (b) { b.closest('.llna-stat').hidden = true; });
  }

  bootBinder();
  /* The basket bar waits for something to be added here; this only learns
     what is already in the basket, so those cards say In basket. */
  cartJSON().then(function () { repaintActions(); }).catch(function () {});

  loadFeed().then(function () {
    refreshToday();
    if (!items.length) { failSoft(); return; }
    feedBinder();
    paintAlso();
    paintStats();
    paintSince();
    refresh();
    paintWatch();
    repaintActions();
    pollSoon();
    /* Back from a product page: the cards are drawn after the page loads,
       so the browser cannot put the scroll back itself. */
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (nav && nav.type === 'back_forward' && saved && saved.y > 0) setTimeout(function () { scrollTo(0, saved.y); }, 80);
    } catch (e) {}
  }).catch(failSoft);
})();
